













import { Component, Vue, Prop } from 'vue-property-decorator'
import { ChatLog } from '@/class/chat'
import MarqueeText from '@/components/Utils/MarqueeText.vue'

export interface MarqueeData {
  id: string;
  text: string;
  positionTop: number;
  isEnd: boolean;
}

@Component({
  components: {
    MarqueeText,
  }
})
export default class Marquee extends Vue {
  @Prop() logs!: ChatLog[];

  public marqueeDataList: MarqueeData[] = [];

  created () {
    this.$watch('logs', () => {
      this.marqueeDataList.push(...this.createMarqueeData());
    })
  }

  end(id: string) {
    const index = this.marqueeDataList.findIndex(m => m.id === id)
    this.marqueeDataList[index].isEnd = true;
  }

  createMarqueeData() {
    const usingPositions = this.marqueeDataList.filter(m => !m.isEnd).map(m => m.positionTop)

    return this.logs
    // .filter(l => l.timestamp && Date.now() - new Date(l.timestamp).getTime() < 3000 )
    .filter(l => !this.marqueeDataList.some(m => m.id === l.id))
    .map(l => {
      const position = this.culcPosition(usingPositions)
      usingPositions.push(position)
      return {
        id: l.id,
        text: `${l.from}:${l.text}`,
        positionTop: position,
        isEnd: false,
      }
    })
  }

  culcPosition(usingPositions: number[]) {
    for(let n = 5; n < 35; n+=2) {
      if (!usingPositions.find(p => p === n)){
        return n;
      }
    }

    return Math.floor(Math.random() * 30) + 5;
  }

}
